import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

const h1 = {
  sm: "20px",
  md: "26px",
};

const h2 = {
  sm: "18px",
  md: "20px",
};

const h3 = {
  sm: "16px",
  md: "16px",
};

const h4 = {
  sm: "16px",
  md: "18px",
};

export const JunoDashboardCard = styled.div`
  color: var(--juno-color-text);
  background-color: var(--juno-color-surface);
  margin-bottom: 16px;
  border-radius: var(--juno-card-radius-sm);
  ${mediaQueries.md} {
    box-shadow: var(--card-shadow, 0 8px 16px 0 rgba(34, 50, 84, 0.06), inset 0 0 0 1px rgba(112, 123, 140, 0.15));
    border-radius: var(--card-radius, var(--juno-radius-md));
  }
`;

export const JunoDashboardCardHeader = styled.div`
  padding: 8px 16px 8px 16px;
  ${mediaQueries.md} {
    padding: var(--card-padding, var(--juno-space-8));
    padding-bottom: 16px;
  }
  h1,
  h2,
  h3,
  h4 {
    max-width: 608px;
  }
`;

export const JunoDashboardCardContent = styled.div`
  font-size: var(--juno-font-size-body-sm);
  padding: 0 16px 16px 16px;
  ${mediaQueries.md} {
    padding: var(--card-padding, var(--juno-space-8));
    padding-top: 0;
  }

  p.small {
    font-size: var(--juno-font-size-body-sm);
    margin-top: -1em;
  }
`;

export const StyledDashboardCardContent = styled.div`
  padding: 0 20px 8px 20px;
  ${mediaQueries.md} {
    padding: 24px 32px;
  }
`;

const JunoHeading = styled.h1`
  font-family: var(--juno-font-family-body);
  font-style: normal;
  line-height: 1.25em;
  font-weight: var(--juno-font-weight-bold);

  margin: 0 0 0.5em 0;

  ${(props) => props.invisible && "visibility: hidden; height: 1px; margin: 0; padding: 0;"};

  &.h1 {
    font-size: ${h1["sm"]};
    ${mediaQueries.md} {
      font-size: ${h1["md"]};
    }
  }

  &.h2 {
    font-size: ${h2["sm"]};
    margin-left: -0.02em;
    ${mediaQueries.md} {
      font-size: ${h2["md"]};
    }
  }

  &.h3 {
    font-size: ${h3["sm"]};
    ${mediaQueries.md} {
      font-size: ${h3["md"]};
    }
  }

  &.h4 {
    font-size: ${h4["sm"]};
    ${mediaQueries.md} {
      font-size: ${h4["md"]};
    }
  }
`;

export const DashboardHeading = ({ level, size, ...props }) => {
  return <JunoHeading as={`h${level}`} className={size ? `h${size}` : `h${level}`} {...props} />;
};

function DashboardCard(props) {
  return (
    <JunoDashboardCard dashboard={props.dashboard} id={props.id} className={props.className}>
      {props.title && (
        <>
          <JunoDashboardCardHeader>
            <DashboardHeading
              level={props.headingLevel ? props.headingLevel : "1"}
              size={props.headingSize ? props.headingSize : "2"}
            >
              {props.title}
            </DashboardHeading>
          </JunoDashboardCardHeader>
          <JunoDashboardCardContent>{props.children}</JunoDashboardCardContent>
        </>
      )}

      {!props.title && <StyledDashboardCardContent>{props.children}</StyledDashboardCardContent>}
    </JunoDashboardCard>
  );
}

export default DashboardCard;
